module.exports = {"id":"157310","name":"Sylvain Marveaux","rating":"74","photo":"./data/images/photos/2/157310.png","club":{"name":"FC Lorient","logo":"./data/images/clubs/FCLorient.png"},"positions":["MOC","BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SylvainMarveaux0.json
// module id = 4064
// module chunks = 0